import { getPageImage } from "@/lib/page-imagery";
const heroImage = getPageImage("/");
import { content, whatsappUrl } from "@/lib/content";
import { useLanguage } from "@/lib/language";

export function Hero() {
  const { t } = useLanguage();
  return (
    <section
      className="relative isolate overflow-hidden bg-[#f5f3ef]"
      aria-labelledby="home-heading"
    >
      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-7 px-6 py-8 sm:gap-10 sm:px-8 sm:py-20 lg:grid-cols-2 lg:gap-16 lg:py-24">
        <figure className="min-w-0 lg:order-last">
          <img
            src={heroImage.src}
            alt={t(heroImage.alt)}
            width={1200}
            height={800}
            fetchPriority="high"
            decoding="async"
            className="aspect-[3/2] w-full rounded-lg object-cover"
          />
        </figure>
        <div className="max-w-xl text-start">
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
            {t(content.topbar.location)}
          </p>
          <h1
            id="home-heading"
            className="mt-6 text-[2rem] font-semibold leading-[1.22] tracking-tight text-foreground sm:text-[2.75rem] lg:text-[3rem]"
          >
            {t(content.hero.title)}
          </h1>
          <p className="mt-6 max-w-md text-base leading-relaxed text-muted-foreground sm:text-lg">
            {t(content.hero.subtitle)}
          </p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-cta="home-hero-whatsapp"
            className="mt-8 inline-flex min-h-12 items-center gap-4 rounded-md bg-primary px-6 py-3.5 text-base font-semibold text-primary-foreground transition hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary"
          >
            {t(content.hero.cta)}
          </a>
        </div>
      </div>
    </section>
  );
}
